import React from "react";

const HisEdit = ({ color = "#708FBB", sx = {} }) => {
  return (
    <svg
      style={sx}
      stroke={color}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3309_43231)">
        <path
          d="M14.25 2.95502C14.4624 2.74265 14.7145 2.57418 14.992 2.45925C15.2694 2.34431 15.5668 2.28516 15.8672 2.28516C16.1675 2.28516 16.4649 2.34431 16.7424 2.45925C17.0199 2.57418 17.272 2.74265 17.4844 2.95502C17.6967 3.16739 17.8652 3.41951 17.9801 3.69699C18.0951 3.97447 18.1542 4.27187 18.1542 4.5722C18.1542 4.87254 18.0951 5.16994 17.9801 5.44742C17.8652 5.7249 17.6967 5.97702 17.4844 6.18939L6.56836 17.1054L2.12109 18.3183L3.33398 13.871L14.25 2.95502Z"
          stroke="#0B4EDB"
          strokeWidth="1.61719"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3309_43231">
          <rect
            width="19.4062"
            height="19.4062"
            fill="white"
            transform="translate(0.503906 0.529297)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HisEdit;
